import config from 'crm/config'

const storeApi = `${config.apiHost}/oem-profile`
const taskApi = `${config.apiHost}/oem-task-system`

export default {
    // 门店分组树
    groups: {
        url: `${storeApi}/api/stores/groups/tree`,
        type: 'GET',
    },
    taskDetail: {
        url: `${taskApi}/api/tasks/{id}/detail`,
        type: 'GET',
    },
    list: {
        url: `${taskApi}/api/tasks/{id}/stores`,
        type: 'GET',
    },
    storeFeedbackList: {
        url: `${taskApi}/api/task-stores/{store_id}/feedbacks`,
        type: 'GET',
    },
    exportDetailData: {
        url: `${taskApi}/api/tasks/{task_id}/stores/export`,
        type: 'GET',
    },
}
